import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.notice.user.list');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router';

@Component({
    selector: 'wiz-portal-notice-user-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.notice.user.list/view.scss */
/* src/app/portal.notice.user.list/view.scss: no such file or directory */`],
})
export class PortalNoticeUserListComponent implements OnInit, DoCheck {
    constructor(@Inject( Service) public service: Service,@Inject( Router)         private router: Router) { }

    // 현재 활성 탭: 'alerts' | 'usage'
    // public activeTab = 'alert';
    public category: any;

    public pagenation: any = {
        page: 1,
        end: 1,
        start: 1,
    };
    public search_word = "";

    public notices = [];

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/authenticate");
        this.category = WizRoute.segment.category;
        await this.load();
        await this.service.render();
    }

    public async ngDoCheck() {
        if (this.category != WizRoute.segment.category) {
            this.category = WizRoute.segment.category;
            await this.load();
        }
    }

    public async load() {
        const { code, data } = await wiz.call("load", { category: this.category, page: this.pagenation.page, search: this.search_word });
        if (code != 200) return await this.service.href("/");;
        this.notices = data.notices;
        this.pagenation.start = (parseInt(this.pagenation.page / 11) * 10) + 1;
        this.pagenation.end = data.lastpage;
        await this.service.render();
    }

    private pageLoad(p: number) {
        this.pagenation.page = p;
        this.load();
    }

    // 탭 전환
    // public setActiveTab(tab: string) {
    //     this.activeTab = tab === 'use' ? 'use' : 'alert';
    // }
    public async setActiveTab(category: string) {
        this.category = category;
        this.router.navigate(['notice', category]);
        await this.load();
    }

    // 현재 탭의 데이터
    public currentNotices() {
        return this.category === 'alert' ? this.alertNotices : this.usageNotices;
    }
}

export default PortalNoticeUserListComponent;